import React from "react";
import { Button, Stack, TextField } from "@mui/material";
import TabLayout from "../../helpers/TabLayout";
import useTextField from "../../../hooks/useTextField";
import useInfoSnackbar from "../../../hooks/useInfoSnackbar";
import { sessionUpdatePassword } from "../../../api/session";

const PasswordTab = () => {
  const currentPassword = useTextField();
  const newPassword = useTextField();
  const newPasswordRepeat = useTextField();
  const infoSnackbar = useInfoSnackbar();

  const handleInputChange = (event, setter) => {
    setter(event.target.value);
    resetErrors();
  };

  const resetErrors = () => {
    currentPassword.resetError();
    newPassword.resetError();
    newPasswordRepeat.resetError();
  };

  const resetFields = () => {
    currentPassword.resetText();
    newPassword.resetText();
    newPasswordRepeat.resetText();
  };

  const handlePasswordUpdate = async () => {
    const response = await sessionUpdatePassword(
      currentPassword.value,
      newPassword.value,
      newPasswordRepeat.value);
    switch (response.code) {
      case "SUCCESS": {
        infoSnackbar.alertSuccess(response.message);
        resetFields();
        break;
      }
      case "INCORRECT_OLD_PASSWORD":
        currentPassword.alertError(response.message);
        break;
      case "INVALID_PASSWORD":
      case "PASSWORD_MISMATCH":
      case "REUSED_PASSWORD": {
        newPassword.alertError(response.message);
        newPasswordRepeat.alertError();
        break;
      }
      default: {
        infoSnackbar.alertError(response.message);
        break;
      }
    }
  };

  return (
    <TabLayout
      headerLabel="Password"
      skeletonLines={14}
    >
      <Stack
        spacing={3}
        alignItems="center"
      >
        <Stack
          spacing={3}
          width="60%"
          pb={5}>
          <TextField
            type="password"
            required={true}
            value={currentPassword.value}
            onChange={event =>
              handleInputChange(event, currentPassword.setValue)}
            error={currentPassword.error}
            helperText={currentPassword.helperText}
            label={"Current password"}
            style={{ marginBottom: 30 }}
          />
          <TextField
            type="password"
            required={true}
            value={newPassword.value}
            onChange={event =>
              handleInputChange(event, newPassword.setValue)}
            error={newPassword.error}
            helperText={newPassword.helperText}
            label={"New password"}
          />
          <TextField
            type="password"
            required={true}
            value={newPasswordRepeat.value}
            onChange={event =>
              handleInputChange(event, newPasswordRepeat.setValue)}
            error={newPasswordRepeat.error}
            helperText={newPasswordRepeat.helperText}
            label="Confirm new password"
          />
        </Stack>
        <Stack>
          <Button
            variant="contained"
            onClick={handlePasswordUpdate}
            disabled={
              !currentPassword.value ||
              !newPassword.value ||
              !newPasswordRepeat.value}
          >
            Update Password
          </Button>
        </Stack>
      </Stack>
    </TabLayout>
  );
};

export default PasswordTab;